import { useState } from "react";
import HumbeeModal from "../../../v2/MUI_custom_component/Modal/HumbeeModal";
import DataLostSvg from "../../Illustrration/components/DataLostSvg";

import { deleteAccountAction } from "./API/Action/index";
import { toast } from "react-toastify";

export const DeleteAccount = ({
  open,
  onClose,
  deleteAccountModalInfo,
  onAccountDeleted,
}) => {
  const [loading, setLoading] = useState(false);

  const { showWarning, headerText, subHeaderText } =
    deleteAccountModalInfo || {};

  const deleteAccount = async () => {
    setLoading(true);
    const { error, message } = await deleteAccountAction();
    setLoading(false);

    if (!error) {
      await onAccountDeleted();
    } else {
      toast.error(message || "Something went wrong");
    }
  };

  return (
    <HumbeeModal
      open={open}
      onClose={onClose}
      onConfirm={showWarning ? null : deleteAccount}
      loading={loading}
      title={headerText}
      subtitle={subHeaderText}
      hideConfirmLabel={showWarning}
      cancelLabel={showWarning ? "Okay" : "No"}
      textButton={showWarning}
      illustration={<DataLostSvg />}
    />
  );
};
